import { MultiLanguage } from "./MultiLanguage";

export interface IProcessConfigurationGroup {
    id: string;
    groupType: number;
    title: MultiLanguage;
}

export function findProcessConfigurationGroup(processConfigurationGroups: any[] | undefined, groupId: string): IProcessConfigurationGroup | undefined {
    const foundGroup = processConfigurationGroups
        ? processConfigurationGroups.find(processConfig => processConfig.id === groupId)
        : undefined;
    return foundGroup ? { ...foundGroup, title: new MultiLanguage(foundGroup.title || {}) } : undefined;
}
